// extracted by mini-css-extract-plugin
export default {"container":"CardFooter-module__container___w6iuJ"};